/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'file-upload';
const prefix = `${moduleName}.${componentName}`;

export const uploadBtnLabel = `${prefix}.uploadBtnLabel`;
export const chooseFileInputPlaceholder = `${prefix}.chooseFileInputPlaceholder`;
export const fileAttachedLabel = `${prefix}.fileAttachedLabel`;

export const ENGLISH = {
    [uploadBtnLabel]: 'Upload File',
    [chooseFileInputPlaceholder]: 'choose file',
    [fileAttachedLabel]: 'file attached',
};
